module.exports = __webpack_public_path__ + "img/south-sudan.17098444.svg";